import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner
} from "reactstrap";

const EditDriverModal = ({
  isOpen,
  toggle,
  formData,
  handleInputChange,
  handleUpdateDriver,
  isLoading
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Driver</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleUpdateDriver}>
          <FormGroup>
            <Label for="name">Full Name</Label>
            <Input
              type="text"
              name="name"
              id="name"
              placeholder="First Name"
              value={formData.name}
              onChange={handleInputChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              value={formData.email}
              disabled
            />
          </FormGroup>

          <div className="d-flex justify-content-end">
            <Button color="primary" disabled={isLoading}>
              {isLoading ? <Spinner size="sm" /> : "Update"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default EditDriverModal;
